export const ORG_PRESETS = [
  { key:'university', label:'University / College', icon:'🎓', member_label:'Student', members_label:'Students', id_field_label:'Index Number', session_label:'Lecture', sessions_label:'Lectures', group_label:'Course', groups_label:'Courses', location_label:'Lecture Hall', locations_label:'Lecture Halls', attendance_label:'Attendance' },
  { key:'school', label:'School (K-12)', icon:'🏫', member_label:'Pupil', members_label:'Pupils', id_field_label:'Student ID', session_label:'Class', sessions_label:'Classes', group_label:'Subject', groups_label:'Subjects', location_label:'Classroom', locations_label:'Classrooms', attendance_label:'Attendance' },
  { key:'office', label:'Office / Company', icon:'🏢', member_label:'Employee', members_label:'Employees', id_field_label:'Staff ID', session_label:'Shift', sessions_label:'Shifts', group_label:'Department', groups_label:'Departments', location_label:'Office', locations_label:'Offices', attendance_label:'Check-in' },
  { key:'church', label:'Church / Religious Org', icon:'⛪', member_label:'Member', members_label:'Members', id_field_label:'Member No.', session_label:'Service', sessions_label:'Services', group_label:'Ministry', groups_label:'Ministries', location_label:'Venue', locations_label:'Venues', attendance_label:'Attendance' },
  { key:'training', label:'Training / Workshop', icon:'📋', member_label:'Participant', members_label:'Participants', id_field_label:'Registration No.', session_label:'Session', sessions_label:'Sessions', group_label:'Programme', groups_label:'Programmes', location_label:'Room', locations_label:'Rooms', attendance_label:'Sign-in' },
  { key:'custom', label:"Something else — I'll customise", icon:'✏️', member_label:'Member', members_label:'Members', id_field_label:'ID Number', session_label:'Session', sessions_label:'Sessions', group_label:'Group', groups_label:'Groups', location_label:'Location', locations_label:'Locations', attendance_label:'Attendance' },
]

export const PLANS = [
  {
    key: 'starter',
    name: 'Starter',
    price: 150,
    currency: 'GH₵',
    period: 'year',
    color: '#2563eb',
    limits: { sessions: 3, members: 60, lecturers: 3 },
    features: [
      'Up to 60 members',
      'Up to 3 sessions',
      'Up to 3 lecturer invites',
      'GPS + device lock',
      'Basic attendance log',
      'Announcement board',
      'CSV export',
      'Manual member entry only',
    ],
    missing: [
      'No bulk import',
      'No analytics',
      'No vanity URL',
      'No member scorecard',
    ],
  },
  {
    key: 'pro',
    name: 'Pro',
    price: 450,
    currency: 'GH₵',
    period: 'year',
    popular: true,
    color: '#7c3aed',
    limits: { sessions: null, members: null, lecturers: null },
    features: [
      'Unlimited members',
      'Unlimited sessions',
      'Unlimited lecturer invites',
      'Everything in Starter',
      'Bulk import via Excel/CSV',
      'Analytics charts & scorecard',
      'At-risk member alerts',
      'Quick stats dashboard',
      'XLS + CSV export',
      'Custom vanity URL slug',
      'Full portal branding',
    ],
    missing: [],
  },
]

export const PLAN_FEATURES = {
  starter: {
    analytics:       false,
    scorecard:       false,
    atRisk:          false,
    vanitySlug:      false,
    bulkImport:      false,
    xlsExport:       false,
    unlimitedInvites: false,
    scheduleImport:  false,
  },
  pro: {
    analytics:       true,
    scorecard:       true,
    atRisk:          true,
    vanitySlug:      true,
    bulkImport:      true,
    xlsExport:       true,
    unlimitedInvites: true,
    scheduleImport:  false, // coming soon on all plans
  },
  // ── institution plan: superset of pro ──────────────────────────
  // Without this key, Admin.jsx line 62 crashes: PLAN_FEATURES[org.plan]
  // returns undefined, then features.analytics throws TypeError.
  institution: {
    analytics:       true,
    scorecard:       true,
    atRisk:          true,
    vanitySlug:      true,
    bulkImport:      true,
    xlsExport:       true,
    unlimitedInvites: true,
    scheduleImport:  false,
  },
}

export const ORG_LAYOUT = {
  university: { showGPS: true,  showGroups: true,  showShifts: false, primaryColor: '#1d4ed8', accent: '#dbeafe' },
  school:     { showGPS: true,  showGroups: true,  showShifts: false, primaryColor: '#0f766e', accent: '#ccfbf1' },
  office:     { showGPS: false, showGroups: true,  showShifts: true,  primaryColor: '#374151', accent: '#f3f4f6' },
  church:     { showGPS: false, showGroups: true,  showShifts: false, primaryColor: '#7c2d12', accent: '#fef3c7' },
  training:   { showGPS: true,  showGroups: false, showShifts: false, primaryColor: '#065f46', accent: '#d1fae5' },
  custom:     { showGPS: true,  showGroups: true,  showShifts: false, primaryColor: '#4f46e5', accent: '#ede9fe' },
}

export const DAYS = [
  { key:'mon', label:'Mon' }, { key:'tue', label:'Tue' }, { key:'wed', label:'Wed' },
  { key:'thu', label:'Thu' }, { key:'fri', label:'Fri' }, { key:'sat', label:'Sat' }, { key:'sun', label:'Sun' },
]

export const GPS_WARNING = (lat, lng, radius, venueName) =>
  `⚠️ LOCATION CALIBRATION\n\nVenue: ${venueName}\nLatitude: ${lat}\nLongitude: ${lng}\nRadius: ${radius}m\n\nMembers must be within ${radius}m of this point.\nMake sure you are standing INSIDE the venue.\n\nSave this location?`
